import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { IonItemSliding } from "@ionic/angular";
import { AlertService } from "src/service/alert.service";
import { SystemRouterService } from "src/service/system-router.service";
import { Resident } from "src/model/class/general classes/resident";

@Component({
    selector: "app-resident",
    templateUrl: "./resident-component.html",
    styleUrls: ["./resident-component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResidentComponent {
  @Input() resident: Resident;
  /** Desktop shows the actions as buttons; touch devices reveal them by swiping */
  @Input() isDesktop: boolean = false;
  @Input() unlinkResidentConfirmTitle: string;
  @Input() unlinkResidentConfirmMsg: string;

  @Output() onUnlinkResident = new EventEmitter<number>();

  constructor(
    private _systemRouterService: SystemRouterService,
    private _alertService: AlertService
  ) {}

  /**
   * Initials shown in the avatar (name + surname)
   */
  public get initials(): string {
    return (
      (this.resident?.name?.trim().charAt(0) ?? "") +
      (this.resident?.surname?.trim().charAt(0) ?? "")
    ).toUpperCase();
  }

  /**
   * Open the edit page of the resident
   * @param item IonItemSliding
   * @param idSelectedResident id of the selected resident
   */
  public onClickEditResident(item: IonItemSliding, idSelectedResident: number): void {
    item?.close();
    this._systemRouterService.navigateResidentsDetailsEdit(idSelectedResident);
  }

  /**
   * Ask for confirmation, then remove the resident from the address book
   * @param item IonItemSliding
   * @param idSelectedResident id of the selected resident
   */
  public async onClickUnlinkResident(
    item: IonItemSliding,
    idSelectedResident: number
  ): Promise<void> {
    try {
      const alertResponse: boolean =
        await this._alertService.presentAlertConfirmOrDismiss(
          this.unlinkResidentConfirmTitle,
          "",
          this.unlinkResidentConfirmMsg
        );
      if (alertResponse) {
        this.onUnlinkResident.emit(idSelectedResident);
      }
    } catch (error) {
      await this._alertService.presentAlertSomethingWrong();
    } finally {
      item?.close();
    }
  }
}
